/* unplugin-vue-components disabled */import script from "./prompt.vue?vue&type=script&setup=true&lang=ts"
export * from "./prompt.vue?vue&type=script&setup=true&lang=ts"

import "./prompt.vue?vue&type=style&index=0&id=2e775c8c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e775c8c"]])

export default __exports__